import ptBR from './ptBR.js'
import enUS from './enUS.js'
import esCL from './esCL.js'
// import brStatesAndCities from './brStatesAndCountries.js'

export const messages = {
    ptBR,
    enUS,
    esCL,
    // brStatesAndCities
}
